import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, '')}${path}`
  }
  return path
}

export interface Tenant {
  tenantId: string
  name: string
  description?: string | null
  location?: string | null
  statusId?: string | null
  activeUsers: number
  maxUser?: number | null
  isEpermitSystem: boolean
  isReportingSystem: boolean
  isAuditTrail: boolean
  isMultiLanguage: boolean
  isAutoApprove: boolean
  isEmailNotifications: boolean
  workflowLevelId?: string | null
  backupFrequencyId?: string | null
  isActive: boolean
  createdAt: string
}

export interface TenantUpsertPayload {
  name: string
  description?: string | null
  location?: string | null
  statusId?: string | null
  maxUser?: number | null
  isEpermitSystem: boolean
  isReportingSystem: boolean
  isAuditTrail: boolean
  isMultiLanguage: boolean
  isAutoApprove: boolean
  isEmailNotifications: boolean
  workflowLevelId?: string | null
  backupFrequencyId?: string | null
  isActive: boolean
}

export async function getTenants(): Promise<Tenant[]> {
  const response = await axios.get<Tenant[]>(buildUrl('/api/v1/tenants'))
  return response.data ?? []
}

export const getActiveTenants = getTenants

export async function getTenantById(tenantId: string): Promise<Tenant> {
  const response = await axios.get<Tenant>(buildUrl(`/api/v1/tenants/${tenantId}`))
  return response.data
}

export async function createTenant(payload: TenantUpsertPayload): Promise<Tenant> {
  const response = await axios.post<Tenant>(buildUrl('/api/v1/tenants'), payload)
  return response.data
}

export async function updateTenant(tenantId: string, payload: TenantUpsertPayload): Promise<Tenant> {
  const response = await axios.post<Tenant>(buildUrl(`/api/v1/tenants/${tenantId}`), payload)
  return response.data
}

export async function deleteTenant(tenantId: string): Promise<void> {
  await axios.delete(buildUrl(`/api/v1/tenants/${tenantId}`))
}
